import { DocumentHistoryEntry, GroupedDocumentHistory } from "@/atoms/documentHistory";
import { DocumentHistoryStore } from "@/stores/DocumentHistoryStore";

const MAX_DOCUMENT_HISTORY_ENTRIES = 30;

export class DocumentHistoryUsecase {
  static list(userId: string): DocumentHistoryEntry[] {
    return DocumentHistoryStore.load(userId);
  }

  static add(
    userId: string,
    current: DocumentHistoryEntry[],
    entry: Omit<DocumentHistoryEntry, "createdAt">,
  ): DocumentHistoryEntry[] {
    const now = Date.now();
    const filtered = current.filter(
      (e) => !(e.documentId === entry.documentId && e.pageNo === entry.pageNo),
    );
    const newEntry: DocumentHistoryEntry = { ...entry, createdAt: now };
    const updated = [newEntry, ...filtered].slice(0, MAX_DOCUMENT_HISTORY_ENTRIES);
    DocumentHistoryStore.save(userId, updated);
    return updated;
  }

  static remove(
    userId: string,
    current: DocumentHistoryEntry[],
    entry: Pick<DocumentHistoryEntry, "documentId" | "pageNo">,
  ): DocumentHistoryEntry[] {
    const updated = current.filter(
      (e) => !(e.documentId === entry.documentId && e.pageNo === entry.pageNo),
    );
    DocumentHistoryStore.save(userId, updated);
    return updated;
  }

  static removeAll(userId: string): void {
    DocumentHistoryStore.save(userId, []);
  }

  static groupByDate(entries: DocumentHistoryEntry[]): GroupedDocumentHistory {
    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();

    // Monday-start week
    const day = now.getDay();
    const daysSinceMonday = day === 0 ? 6 : day - 1;
    const weekStart = new Date(now.getFullYear(), now.getMonth(), now.getDate() - daysSinceMonday).getTime();

    const today: DocumentHistoryEntry[] = [];
    const thisWeek: DocumentHistoryEntry[] = [];
    const before: DocumentHistoryEntry[] = [];

    for (const entry of entries) {
      if (entry.createdAt >= todayStart) {
        today.push(entry);
      } else if (entry.createdAt >= weekStart) {
        thisWeek.push(entry);
      } else {
        before.push(entry);
      }
    }

    return { today, thisWeek, before };
  }
}
